import React from "react";
import CustomModal from "../CustomModal/CustomModal";
import { useTranslation } from "react-i18next";
import { translationConstants } from "../../../constants";
import { Col, Row } from "react-bootstrap";

const ViewCertificateAttachments = ({
  isViewAttachmentModal,
  setViewAttachmentModal,
  qualifications,
  isLocalFiles = false,
}) => {
  const { t } = useTranslation();
  return (
    <CustomModal
      size="md"
      scrollable={true}
      customClass="view-user-modal"
      show={isViewAttachmentModal}
      setShow={setViewAttachmentModal}
      closeOnOutsideClick={true}
    >
      <section>
        <p className="fs-6 fw-bold">{t(translationConstants.ATTACHMENTS)}</p>
        <p className="horizentalLine" />
        {qualifications?.map((file, index) => (
          <Row key={index} className="align-items-center">
            {isLocalFiles ? (
              <Col>
                <p
                  className="text-break font-14 underline center-card-view-detail-link approved-color"
                  onClick={() =>
                    window.open(URL.createObjectURL(file), "_blank")
                  }
                >
                  {file.name}
                </p>
              </Col>
            ) : (
              <Col>
                <a
                  href={file.link}
                  target="_blank"
                  rel="noreferrer"
                  className="font-14 underline center-card-view-detail-link approved-color"
                >
                  <span className="text-break">{file.originalFileName}</span>
                </a>
              </Col>
            )}
          </Row>
        ))}
      </section>
    </CustomModal>
  );
};

export default ViewCertificateAttachments;
